// extracted by mini-css-extract-plugin
module.exports = {"tags":"_9e1425b4d3--tags--XX_6a","tags_schema_org":"_9e1425b4d3--tags_schema_org--X2mvx","tags__link":"_9e1425b4d3--tags__link--JTFNr"};